module.exports = __webpack_public_path__ + "static/L2_content_user_input_5_do-2a4d0fa693cc06f48077bb58e64002e1.png";